/* eslint-disable import/no-anonymous-default-export */

import { AUTH_PRODUCT_TYPE } from '../constants/app-constants';
import getAccessToken from '../utils/helpers/get-access-token';
import qs from 'querystring';

export default (api) => {
    const getUserConsent = (payload, xCountryCode = 'AE', product = AUTH_PRODUCT_TYPE) => {
        return api.post(`consent/${product}`, payload, {
            headers: {
                X_COUNTRY: xCountryCode
            }
        });
    };

    const userDeactivation = (payload) => {
        return api.post(`user-profile`, payload, {
            headers: {
                Authorization: `Bearer ${getAccessToken()}`,
            }
        });
    };

    const handleDealerWatchList = (payload) => {
        return api.post(`secure/v1/shortlist`, payload, {
            headers: {
                Authorization: `Bearer ${getAccessToken()}`,
            }
        });
    };
    const fetchDealerWatchList = (payload) => {
        return api.get(`secure/v1/shortlist?${qs.stringify(payload)}`, {
            headers: {
                Authorization: `Bearer ${getAccessToken()}`,
            }
        });
    };

    return {
        getUserConsent,
        userDeactivation,
        handleDealerWatchList,
        fetchDealerWatchList
    };
};
